import fileService from '@/services/file.service';
import Image from  '@/models/Image';
import Formatter from '@/functions/Formatter';
import FileDownload from 'js-file-download';

const state = {
    files: [],
    media: []
}

const mutations = {
    ADD_FILE(state, file){
        state.files.push(file);
        
    },
    ADD_FILES(state, files){
        state.files.push(...files);
    },
    REMOVE_FILE(state, fileId){
        state.files = state.files.filter(f => f.id != fileId);
    },
    ADD_MEDIA(state, media){
        state.media.push(media);
    },
    REMOVE_MEDIA(state, mediaId){
        state.media = state.media.filter(i => i.id != mediaId)
    },
    CLEAR_STATE(state){
        state.files = [];
        state.media = [];
    }
}
const actions = {
    async fetchImageById({commit, getters}, imageId){
        if(!imageId) return null;

        let image = getters.getFileById(imageId);
        if(image) { return image; }

        try {
            let response = await fileService.getOne(imageId);
            image = Formatter.formatImage(response.data);
            commit('ADD_MEDIA', image);
            return image;
        } 
        catch (error) {
            console.log(error);
            return null;
        }
    },
    async uploadImage({commit}, image){
        let formdata = new FormData();
        formdata.append('files', image);

        try {
            let response = await fileService.upload(formdata);
            let image = Formatter.formatImage(response.data[0]);
            commit('ADD_MEDIA', image);
            return image;
        } 
        catch (error) {
            console.log(error);
            return new Image();
        }  
    },
    async uploadImageWithRef(_, payload){
        let formdata = new FormData();
        formdata.append('files', payload.image);
        formdata.append('field', payload.field);
        formdata.append('ref', payload.ref);
        formdata.append('refId', payload.refId);
        if(payload.source)
            formdata.append('source', payload.source)

        try {
            let response = await fileService.upload(formdata);
            let image = Formatter.formatImage(response.data[0]); 
            return image;
        } 
        catch (error) {
            console.log(error);
            return new Image();
        }
    },
    async deleteMedia({commit}, mediaId){
        if(!mediaId)
            return;
        
        try{
            const response = await fileService.delete(mediaId);
            commit('REMOVE_MEDIA', mediaId);
            return response;
        }
        catch (error){
            console.log(error);
        }
    },
    async uploadFiles({commit}, files){
        if(!files || !files?.length) return;
        
        let formdata = new FormData();
        files = Array.from(files);
        for (let i = 0; i < files.length; i++) {
            formdata.append('files', files[i]);
        }
        
        try {
            let response = await fileService.upload(formdata);
            let files = Formatter.formatFiles(response.data);
            commit('ADD_FILES', files); 
            return files;  
        } 
        catch (error) {
            console.log(error);
        }  
    },
    async deleteFile({commit}, fileId){
        try {
            let response = await fileService.delete(fileId);
            commit('REMOVE_FILE', fileId);
            return response;
        } catch (error) {
            console.log(error);
        }
    },
    async downloadFile(_, file){
        try {
            let response = await fileService.download(file.url);
            FileDownload(response.data, file.name);
        } catch (error) {
            console.log(error);
        }
    },
    clearFiles({ commit }){
        commit("CLEAR_STATE");
    }
}
const getters = {
    getFileById: (state) => (fileId) => {
        return state.media.find(m => m.id == fileId);
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}